import { Avatar, Button, ButtonBase, Stack, Typography } from '@mui/material';
import { AdvancedSearchContext } from 'Context/PaymentDeductionContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { ArrowRightWhite } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';
import { useContext } from 'react';

interface IButtons {
  dispatchPaymentsDeductions: Function;
  closeAdvancedSearch: Function;
}

export const Buttons = ({
  dispatchPaymentsDeductions,
  closeAdvancedSearch,
}: IButtons) => {
  const isDesktop = useIsDesktop();
  const dictionary = Dictionary[DICTIONARY.PaymentsDeductions].search;

  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );

  return (
    <Stack
      direction='row'
      alignItems='center'
      gap={isDesktop ? '60px' : 0}
      justifyContent={isDesktop ? 'flex-end' : 'space-between'}
    >
      <ButtonBase
        sx={{
          width: 'fit-content',
          direction: 'row',
          gap: '7px',
          ':hover': {
            cursor: 'pointer',
            textDecoration: 'underline',
            textDecorationColor: '#1552E8',
          },
        }}
      >
        <Typography
          variant='body1'
          color='primary'
          sx={{ textDecoration: 'underline' }}
          onClick={() => {
            dispatchAdvancedSearch({ type: 'RESET' });
            dispatchPaymentsDeductions({ type: 'RESET' });
          }}
          onKeyDown={onEnterOrEscapeKeyDown}
          tabIndex={0}
        >
          {dictionary.reset}
        </Typography>
      </ButtonBase>
      <Button
        sx={{
          width: isDesktop ? '176px' : '162px',
          bgcolor: 'primary.shade_400',
          boxShadow: '0px 2px 10px rgba(4, 16, 46, 0.06)',
          borderRadius: '100px',
          padding: isDesktop ? '12px 24px' : '10px 24px',
          gap: '4px',
          ':hover': { cursor: 'pointer', bgcolor: 'primary.shade_400' },
        }}
        onClick={() => {
          if (
            advancedSearch.requestNumber &&
            advancedSearch.requestNumber.toString().length < 4
          )
            return;
          dispatchPaymentsDeductions({
            type: 'ADVANCED_SEARCH',
            payload: { value: advancedSearch },
          });
          dispatchAdvancedSearch({
            type: 'ACTIVE_SEARCH_ADVANCED',
            payload: { value: true },
          });
          closeAdvancedSearch(false);
        }}
      >
        <Typography variant={'body4'} color={'#fff'}>
          {dictionary.showResults}
        </Typography>
        <Avatar
          alt={''}
          src={ArrowRightWhite}
          sx={{ width: '20px', height: '20px' }}
        />
      </Button>
    </Stack>
  );
};
